import { render, staticRenderFns } from "./month_mobile_notes.vue?vue&type=template&id=71b870d0&scoped=true&"
import script from "./month_mobile_notes.vue?vue&type=script&lang=js&"
export * from "./month_mobile_notes.vue?vue&type=script&lang=js&"
import style0 from "./month_mobile_notes.vue?vue&type=style&index=0&id=71b870d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b870d0",
  null
  
)

export default component.exports